import axios from 'axios'

const fetchNextService = () => {
  return axios
    .get('/live', { headers: { Accept: 'application/json' } })
    .then((response) => {
      const { next } = response.data

      if (!next) {
        throw 'No service found'
      }

      return {
        startDate: next.feed_start,
        endDate: next.feed_end,
        embed: next.embed,
      }
    })
}

export { fetchNextService }
